import React from 'react';
import PropTypes from 'prop-types';

const NativeSelect = ({ label, invalid, error, data, placeholder, hasEmptyOption = true, ...props }) => {
	return (
		<div className='mb-3'>
			<label className='form-label'>{label}</label>
			<select className={`form-select ${invalid ? 'is-invalid' : ''}`} {...props}>
				{hasEmptyOption && <option value='0'>{placeholder}</option>}
				{data?.map(({ value, label }) => (
					<option value={value} key={value}>
						{label}
					</option>
				))}
			</select>

			{error && error.message && <div className='invalid-feedback'>{error.message}</div>}
		</div>
	);
};

NativeSelect.propTypes = {
	placeholder: PropTypes.string,
	label: PropTypes.string,
	type: PropTypes.string,
	invalid: PropTypes.bool,
	error: PropTypes.object,
	className: PropTypes.string,
	id: PropTypes.string,
	data: PropTypes.array
};
export default NativeSelect;
